import clsx from 'clsx';
import type { FunctionComponent, ReactNode } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import { IconCrossSmall } from '~/ui/core/icons';
import { SCROLL_FADE_HEADER_PROPS } from '~/ui/core/scroll-fade/ScrollFade';
import { TileControlGroup, tileContentEdgeOffsetClassNames } from '~/ui/core/tile/Tile';
import { ActionButtons, HeaderContainer } from '~/ui/domain/Sidepanel/components/SidepanelHeader';

import { CommentsHeaderAction } from '../../../../comments';

export const TaskTileHeader: FunctionComponent<{
    readonly actions?: ReactNode;
    readonly comments?: { readonly isOpen: boolean; readonly onToggle: () => void };
    readonly isSticky?: boolean;
    readonly onClose: () => void;
}> = ({ actions, comments, isSticky = true, onClose }) => {
    const translate = useTranslate();

    return (
        <div
            className={clsx(
                isSticky && 'sticky top-0 z-[1]',
                'bg-surface-raised pb-m pt-tile-edge',
                tileContentEdgeOffsetClassNames,
            )}
            {...(isSticky ? SCROLL_FADE_HEADER_PROPS : {})}
        >
            <HeaderContainer>
                <TileControlGroup>
                    <Button
                        aria-label={translate('common.close')}
                        iconOnly={true}
                        size="sm"
                        variant="secondary"
                        onClick={onClose}
                    >
                        <IconCrossSmall />
                    </Button>
                </TileControlGroup>
                {comments === undefined && actions === undefined ? null : (
                    <ActionButtons>
                        {comments === undefined ? null : (
                            <CommentsHeaderAction isOpen={comments.isOpen} onToggle={comments.onToggle} />
                        )}
                        {actions}
                    </ActionButtons>
                )}
            </HeaderContainer>
        </div>
    );
};
